import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals';
import { cartQuantityStorageKey } from 'CartContext';
import 'i18n';
import TagManager from 'react-gtm-module';
import { useMarketplaceDomain } from 'hooks/useMarketplace';

const marketplaceDomain = useMarketplaceDomain();
const marketName = process.env.REACT_APP_MARKET_NAME || '';
const isDev = (): boolean => {
  const hrefStart = window.location.href.split('.')[0];
  const subdomain = hrefStart.slice(hrefStart.lastIndexOf('/') + 1);
  return subdomain.includes('dev');
};

const tagManagerArgsDev = {
  gtmId: 'GTM-K95S3VW',
};
const tagManagerArgs = {
  gtmId: 'GTM-KW5DCCJ',
};
const tagManagerArgsIMM = {
  gtmId: 'GTM-53M6VVF',
};

if (isDev() || marketplaceDomain?.includes('localhost')) {
  TagManager.initialize(tagManagerArgsDev);
} else if (marketName === 'communicationssector') {
  TagManager.initialize(tagManagerArgsIMM);
} else {
  TagManager.initialize(tagManagerArgs);
}

const root = document.getElementById('root');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  root,
);

const sendSizeMessage = () => {
  const message = {
    source: 'bex-storefront',
    payload: {
      type: 'window-size',
      path: window.location.pathname,
      payload: {
        height: document.body.scrollHeight,
        width: document.body.scrollWidth,
      },
    },
  };
  window.top?.postMessage(message, '*');
};

if (root) {
  new MutationObserver(sendSizeMessage).observe(root, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  });
}

const sendCartQuantityMessage = (quantity: string) => {
  const message = {
    source: 'bex-storefront',
    payload: {
      type: 'cart-quantity',
      path: window.location.pathname,
      payload: {
        quantity,
      },
    },
  };
  window.top?.postMessage(message, '*');
};

setInterval(() => {
  const quantity = localStorage.getItem(cartQuantityStorageKey) || '0';
  sendCartQuantityMessage(quantity);
}, 1000);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
